// src/components/Payment/addbanner.js
import React from 'react';

const Activatemembertxn = () => {
  return (
    <div>
      <h2>activatemembertxn</h2>
      <p>This is the addbanner component.</p>
    </div>
  );
};

export default Activatemembertxn;
